import styled from '@emotion/styled'

const MenuUl = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
  list-style: none;
  margin-bottom: 0 !important;
`

export default MenuUl
